import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, Thumbs,EffectFade } from 'swiper/modules';
Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';
import 'swiper/css/thumbs'; 

document.addEventListener('DOMContentLoaded', () => {

const swiper1 = document.querySelector('.swiper-main');
const progressLine = document.querySelector('.progress');

const baseConfig = {
    modules: [Navigation, Pagination, Autoplay],
    loop: true,
    slidesPerView: "auto",
    spaceBetween: 0,
        effect:'fade',
     autoplay: {
        delay: 3000, // время между автопереключениями
        disableOnInteraction: false // не отключать автоплей после ручного переключения
    },
    speed: 1000,
      slidesPerView: 1,
     on: {
        autoplayTimeLeft(s, time, progress) {
          progressLine.style.setProperty("--progress", 1 - progress);
          // console.log(time)
          // progressLine.style.setProperty("--progress", progress);
          // progressContent.textContent = `${Math.ceil(time / 1000)}s`;
        }},


       breakpoints: {
    768: {
      slidesPerView: 'auto',
      spaceBetween: 0
    },}
};
if (swiper1) {
  const swiper = new Swiper(swiper1, {
    ...baseConfig,
    navigation: {
        nextEl: '.sbutton-next',
        prevEl: '.sbutton-prev',
    },
});  
}




});

